import { Injectable } from '@angular/core';
import { User } from '../core/models/user.model';
import { AuthService } from '../core/authencation/auth.service';
import {  map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserService {

    public user: User = null;

    constructor(public authService: AuthService) {

    }

    enableFunctionByCode(code: string) {
        return this.authService.hasPermission(code);
    }

    getuserName(){
        return this.authService.getuserName();
    }

    async getUserRole(){
        return (await new Observable(subscribe => {
            this.authService.userData.subscribe(
                user => {
                  subscribe.next(user? user.role : null);
                  subscribe.complete();
                }
              );
          }).toPromise()) as any;
    }
}
